import { DomainError } from "@/entities/error.ts";
import { ContactpersoonDto } from "@/shared/types";
import { capitalizeFirstChar } from "@/shared/utils";
import { Functie } from "./constants";

export type Contactpersoon = {
    id: number;
    naam: string | undefined;
    telefoonnummer: string;
    functie: Functie;
    stationcode?: string;
    treinnummer?: number;
};

export const Contactpersoon = {
    fromDto(dto: ContactpersoonDto): Contactpersoon {
        return {
            id: dto.id,
            naam: dto.naam,
            telefoonnummer: dto.telefoonnummer,
            functie: dto.functie as Functie,
            stationcode: dto.stationcode,
            treinnummer: dto.treinnummer,
        };
    },
    sort: (a: Contactpersoon, b: Contactpersoon) => {
        if (a.naam && b.naam) {
            return a.naam.localeCompare(b.naam);
        }
        if (a.naam) return -1;
        if (b.naam) return 1;
        return a.id - b.id;
    },
    getLocation(cp: Contactpersoon) {
        switch (cp.functie) {
            case "HC":
            case "MCN":
            case "WOR":
            case "WOP":
                if (!cp.treinnummer) throw new DomainError(`Expected treinnummer for contactpersoon ${cp.id} with functie ${cp.functie}`);
                return cp.treinnummer;
            case "MOL":
            case "VOS":
                if (!cp.stationcode) throw new DomainError(`Expected stationcode for contactpersoon ${cp.id} with functie ${cp.functie}`);
                return cp.stationcode;
        }
    },
    getFunctieEnLocatie(cp: Contactpersoon) {
        const location = Contactpersoon.getLocation(cp);
        return [cp.functie, capitalizeFirstChar(String(location))];
    },
    // Voorbeeld: "Jan (HC 1234)", of alleen "HC 1234" als naam undefined is.
    getDisplayName(cp: Contactpersoon) {
        const functieEnLocatie = Contactpersoon.getFunctieEnLocatie(cp).join(" ");
        return cp.naam ? `${cp.naam} (${functieEnLocatie})` : functieEnLocatie;
    },
    // Voorbeeld: "Jan | HC", of alleen "HC" als naam undefined is.
    getNaamEnFunctie(cp: Contactpersoon) {
        return cp.naam ? `${cp.naam} | ${cp.functie}` : cp.functie;
    },
};
